import { randomDelay } from "@/lib/utils/sleep";
import {
  getAgencyProfileMock,
  updateAgencyProfileMock,
  type AgencyProfile,
} from "@/lib/mocks/agencyProfile";

// O perfil mock vive no store compartilhado (@/lib/mocks/agencyProfile) — assim o que
// o onboarding grava aparece aqui em Configurações, como no backend real.
export type { AgencyProfile };

export async function getAgencyProfile(): Promise<AgencyProfile> {
  await randomDelay();
  return getAgencyProfileMock();
}

export async function updateAgencyProfile(data: Partial<AgencyProfile>): Promise<AgencyProfile> {
  await randomDelay(800, 1500);
  return updateAgencyProfileMock(data);
}
